import React from 'react'
import { useRef } from 'react'
import { useEffect } from 'react';
import NavBar from '../Navbar/NavBar'
import makeGlitch from '../../app_utilities/makeGlitch'
import './IntroComp.css'

const IntroCmp = () => {

    const textAnimation = useRef(null);
    const bgAnimation = useRef(null);

    useEffect(() =>{
        makeGlitch(bgAnimation, textAnimation);
    }, [textAnimation])

    return (
        <section className='main_sec'>
            <NavBar />
            <div>
                <div className="coverLayer"> {/* div di copertura img gb */} </div>
                <div className='textBgAni textBg' ref={textAnimation}> fix the glitch</div>   
                <div className='animBack'  ref={bgAnimation}>  {/* placeholde img */}  </div>   
            </div>
        </section>
    )
}

export default IntroCmp;